export default {
  data() {
    return {}
  },
  methods: {
    getName(name) {
      let mass = name.split(' ')
      mass = mass.filter((item, index) => index < 2)
      let result = ''
      mass.forEach(item => {
        result = result + item.split('')[0]
      })
      return result
    },
  },
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/builder/speaker/component.js